import Vue from 'vue';
import dialog from './Modal.vue'

let DialogConstructor = Vue.extend(dialog) // 构造函数
let instance // 实例对象

const _Dialog = (options = {}) => {
  instance = new DialogConstructor({
    data: options
  })
  
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  return instance.vm
}

export default _Dialog